import { LitElement, html, css } from 'lit';

class MetalyxButton extends LitElement {
  static properties = {
    variant: { type: String },
    href: { type: String },
  };

  static styles = css`
    :host {
      display: inline-block;
    }
    a, button {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.75rem 1.75rem;
      border-radius: var(--radius-md, 0.75rem);
      font-family: var(--font-sans, 'DM Sans', sans-serif);
      font-size: var(--text-base, 1rem);
      font-weight: 600;
      text-decoration: none;
      cursor: pointer;
      transition: all var(--transition, 200ms ease);
      border: 2px solid transparent;
      line-height: 1.4;
    }

    .primary {
      background: var(--color-accent, #7C3AED);
      color: #FFFFFF;
      border-color: var(--color-accent, #7C3AED);
    }
    .primary:hover {
      background: var(--color-accent-hover, #6D28D9);
      border-color: var(--color-accent-hover, #6D28D9);
      transform: translateY(-1px);
      box-shadow: 0 4px 20px var(--color-accent-glow, rgba(124, 58, 237, 0.3));
    }

    .secondary {
      background: transparent;
      color: var(--color-metalyx-light, #C4B5FD);
      border-color: rgba(124, 58, 237, 0.3);
    }
    .secondary:hover {
      background: var(--color-accent-glow, rgba(124, 58, 237, 0.15));
      color: #DDD6FE;
      border-color: rgba(124, 58, 237, 0.5);
      transform: translateY(-1px);
    }

    .ghost {
      background: transparent;
      color: var(--color-text-primary, #CBD5E1);
      padding: 0.5rem 1rem;
      border: none;
    }
    .ghost:hover {
      color: var(--color-accent, #7C3AED);
    }
  `;

  constructor() {
    super();
    this.variant = 'primary';
    this.href = '';
  }

  _openContact(e) {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('open-contact'));
  }

  render() {
    if (this.href === '#contact') {
      return html`
        <a class="${this.variant}" href="#" @click="${this._openContact}">
          <slot></slot>
        </a>
      `;
    }
    if (this.href) {
      return html`
        <a class="${this.variant}" href="${this.href}">
          <slot></slot>
        </a>
      `;
    }
    return html`
      <button class="${this.variant}" type="button">
        <slot></slot>
      </button>
    `;
  }
}

customElements.define('metalyx-button', MetalyxButton);